import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {Para} from "@irati/ui/src/Labels"
import {H2} from "@irati/ui/src/Headings"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"

import recogniseSuccess from "../../../images/recognise-success.gif"

const Image = styled.img`
  height: 256px;
  margin-bottom: 15px;
  width: 256px;
`

const StyledPara = styled(Para)`
  padding-bottom: ${padding.small};
  padding-top: ${padding.tiny};
`

let closeSuccessTimeout = null

class RecognitionSuccess extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    onClickButton: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    timeoutMilliseconds: PropTypes.number
  }

  static defaultProps = {
    timeoutMilliseconds: 30000
  }

  handleCreateNewRecognition = () => this.props.onClickButton()

  componentDidMount() {
    const {onHide, timeoutMilliseconds} = this.props
    closeSuccessTimeout = setTimeout(() => {
      onHide()
    }, timeoutMilliseconds)
  }

  componentWillUnmount() { clearTimeout(closeSuccessTimeout) }

  render() {
    const {formatMessage} = this.props

    return (
      <div className="text-center">
        <Image
          alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})}
          src={recogniseSuccess} />
        <H2><FormattedMessage id="recognition.popup.createRecognition.success.header" /></H2>
        <StyledPara center large>
          <FormattedMessage id="recognition.popup.createRecognition.success.body" />
        </StyledPara>
        <Button primary large full onClick={this.handleCreateNewRecognition}>
          <FormattedMessage id="recognition.popup.createRecognition.success.createAgainButton" />
        </Button>
      </div>
    )
  }
}

export default injectIntl(RecognitionSuccess)
